import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { buildLoginPath } from './marketingNav';

export default function MarketingLoginLink({ className, children, redirect, onNavigate, style }) {
  const location = useLocation();
  const to = buildLoginPath(redirect ?? location.pathname);

  return (
    <Link
      to={to}
      className={className}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        onNavigate?.();
      }}
    >
      {children}
    </Link>
  );
}
